let comingSoonIds = {
    coming_soon_in_label                :   "Coming Soon in",
    keep_lookout_for_continue_label     :   " Keep a lookout for the Industry's first AI enabled Photography Solution",
    watch_the_space_more_label          :   "WATCH THIS SPACE FOR MORE",
    
}

export default {
    ...comingSoonIds
}